// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SpeakerHighBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M19.659 2.652a1.5 1.5 0 0 0-1.58.164L9.485 9.5H4A2.5 2.5 0 0 0 1.5 12v8A2.5 2.5 0 0 0 4 22.5h5.485l8.594 6.684A1.5 1.5 0 0 0 20.5 28V4a1.5 1.5 0 0 0-.841-1.348ZM4.5 12.5h4v7h-4v-7Zm13 12.433-6-4.667v-8.532l6-4.667v17.866Zm9-8.933a5.5 5.5 0 0 1-1.375 3.639 1.5 1.5 0 0 1-2.25-1.985 2.5 2.5 0 0 0 0-3.304 1.5 1.5 0 0 1 2.25-1.982A5.493 5.493 0 0 1 26.5 16Zm5 0a10.484 10.484 0 0 1-2.674 7 1.5 1.5 0 1 1-2.236-2 7.5 7.5 0 0 0 0-10 1.497 1.497 0 0 1 .094-2.144A1.5 1.5 0 0 1 28.825 9a10.484 10.484 0 0 1 2.675 7Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
